/* eslint implicit-arrow-linebreak: 0 */

import _find from 'lodash/find';
import _matches from 'lodash/matches';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import OPERATORS from '@tekion/tekion-base/constants/filterOperators';
export var getFilterType = function getFilterType(selectedFilterType, filterTypes) {
  return _find(filterTypes, _matches({
    id: selectedFilterType
  }));
};
var CHECK_FIELD_EXISTENCE_OPERATORS = [OPERATORS.EXISTS, OPERATORS.NOT_EXISTS];
export var checkFieldExistenceSelected = function checkFieldExistenceSelected(filterType, value) {
  var operator = value.operator;
  var checkFieldExistence = _get(filterType, 'additional.checkFieldExistence', false);
  return checkFieldExistence && _includes(CHECK_FIELD_EXISTENCE_OPERATORS, operator);
};